import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1>Christian & Mira</h1>
      <p>The moments that made us, and the love that keeps us</p>
    </header>
  );
};

export default Header;